import { Stack, Typography } from '@mui/material';
import { colors } from 'theme/mui/colors';

type Props = {
  quantity: number;
  name: string;
  price?: string;
  visiblePrice?: boolean;
};

const OrderItem = (props: Props) => {
  const { name, quantity, price, visiblePrice } = props;
  return (
    <Stack
      direction="row"
      gap="0.75rem"
      alignItems="center"
      sx={{ py: '1rem', borderBottom: `1px solid ${colors.gray[200]}` }}
    >
      <Stack
        flex={1}
        sx={{
          background: colors.gray[100],
          p: '0.25rem 0.5rem',
          borderRadius: '0.625rem',
          minWidth: '2rem',
          maxHeight: '2rem',
        }}
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="body2">{quantity}</Typography>
      </Stack>
      <Stack flex={1} justifyContent="center" alignItems="center">
        <Typography variant="body2">x</Typography>
      </Stack>
      <Stack flex={10} justifyContent="center">
        <Typography variant="caption">{name}</Typography>
      </Stack>
      {price && visiblePrice ? (
        <Stack flex={7} justifyContent="center">
          <Typography variant="caption">{price}</Typography>
        </Stack>
      ) : null}
    </Stack>
  );
};

export default OrderItem;
